<script setup lang="ts">
import { useImageCdn } from '~/composables/useImageCdn'
import {useWadUrls} from "~/composables/useWadUrls";

const {
  article,
  lazy = true,
} = defineProps<{
  article: Article
  lazy?: boolean
}>();

const { fixedWidthImageParams } = useImageCdn()
const { getPlatformUrl } = useWadUrls();
const {randomColorBySeed} = useWadHelpers();

const articleUrl = getPlatformUrl(`/magazine/${article.id}/${article.slug}`);

const initialsStyle = computed(() => {
  return {
    background: randomColorBySeed(article.author_initials)
  }
})

const goToArticle = () => {
  window.location.href = articleUrl;
}
</script>

<template>
  <article class="wad4-related-article-card">
    <figure class="wad4-related-article-card__image-wrapper" @pointerup="goToArticle">
      <img
          class="wad4-related-article-card__image"
          :alt="article.title"
          :loading="lazy ? 'lazy' : 'eager'"
          v-bind="fixedWidthImageParams(article.thumbnail_url, 120)"
      />
    </figure>
    <div class="wad4-related-article-card__right">
      <header class="wad4-related-article-card__author wad4-related-article-card__author-name">
          {{ article.author_names }}
      </header>
        <a class="wad4-related-article-card__title" :href="articleUrl">
          {{ article.title }}
        </a>
    </div>
  </article>
</template>


<style lang="scss">
.wad4-related-article-card {
  display: flex;
  align-items: flex-start;
  gap: $wad4-spacing-xl;
  flex-wrap: nowrap;
  cursor: default;
  @media (max-width: $wad4-breakpoint-tablet-max) {
    flex-wrap: wrap;
    width: 100%;
  }

  &:hover {
    .wad4-related-article-card__title {
      color: $wad4-c-text-text-primary-hover;
    }
    .wad4-related-article-card__image {
      transform: scale(1.05);
    }
  }


  &__right {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: $wad4-spacing-md;
    flex: 1 0 0;
    align-self: stretch;
  }

  &__author {
    display: flex;
    align-items: center;
    gap: $wad4-spacing-md;

    &-name {
      color: $wad4-c-text-text-tertiery;
      font-size: 0.875rem;
      font-weight: $wad4-font-weight-regular-bold;
      line-height: 1.25rem;
    }

    &-initials{
      border-radius: 33554400px;
      display: flex;
      width: 24px;
      height: 24px;
      padding: 4px 3.633px 4px 4px;
      justify-content: center;
      align-items: center;
      color: $wad4-c-text-text-black;
      font-size: 0.75rem;
      font-weight: $wad4-font-weight-semi-bold;
      line-height: 1rem;
    }
  }

  &__title {
    color: $wad4-c-text-text-primary;
    font-size: 0.875rem;
    font-weight: $wad4-font-weight-semi-bold;
    line-height: 1.25rem;
    text-decoration: none !important;
  }


  &__image {
    object-fit: cover;
    display: block;
    width: 120px;
    height: 84px;
    aspect-ratio: 10/7;
    transition: transform 0.3s ease;

    &-wrapper{
      cursor: pointer;
      align-items: flex-end;
      margin: unset;
      overflow: hidden;
      flex-shrink: 0;
      border-radius: $wad4-border-radius-md;
    }
  }
}

</style>
